import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { SchedulerConfigurationFields } from '../schemas/scheduler-configuration.schema';

/**
 * Sends scheduler configuration data
 * @param schedulerConfiguration The scheduler configuration to be created
 * @returns Data object indicating success
 */
export function postSchedulerConfiguration(
  this: unknown,
  schedulerConfiguration: SchedulerConfigurationFields
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        mapManagementServiceEnvironment.resolve(this).schedulerConfigurationUrl,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(schedulerConfiguration),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
